<template>
  <div style="padding-left: 2%">
    <h1
      class="lead"
      style="font-size: 24px"
    >Welcome to the Ship zone</h1>
    <hr />

    <!-- <button
      type="button"
      class="btn"
      @click="sendOtp()"
    >
      otp
    </button> -->

    <div v-if="!loggedInUserData.is_staff">
      <div v-if="
          !loggedInUserData.phone_number ||
          !loggedInUserData.address ||
          !loggedInUserData.email ||
          !loggedInUserData.full_name
        ">
        <!-- !loggedInUserData.default_branch_id_fk -->
        <h5
          class="lead"
          style="font-size: 18px"
        >
          Please fill out these information
        </h5>
        <v-alert
          :value="successResponse"
          type="success"
        >
          The process was successful
        </v-alert>
        <v-alert
          :value="errorResponse"
          type="error"
        >
          {{ errorMessages.email }}
          {{ errorMessages.phone_number }}
        </v-alert>
        <form @submit.prevent="submitForm">
          <!-- <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.default_branch_id_fk"
          >
            <v-select
              :items="branchesList"
              v-model="customerInfoData.default_branch_id_fk"
              autocomplete
              label="Branch"
              :error-messages="errors.collect('Branch')"
              v-validate="'required'"
              data-vv-name="Branch"
            />
          </v-flex> -->

          <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.full_name"
          >
            <v-text-field
              label="Full name"
              v-model="customerInfoData.full_name"
              :error-messages="errors.collect('Full name')"
              v-validate="'required'"
              data-vv-name="Full name"
            >
            </v-text-field>
          </v-flex>

          <v-flex
            @click="emailHint = true"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.email"
          >
            <v-text-field
              label="Email"
              v-model="customerInfoData.email"
            > </v-text-field>
            <div
              v-if="emailHint === true"
              style="background-color: #ee9600; border-radius: 5px"
            >
              <p style="color: white; padding: 2%;">
                The email must be a real email, because every actions on your order will send to
                this email
              </p>
            </div>
          </v-flex>

          <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.phone_number"
          >
            <div
              class="d-flex"
              style="align-items: center"
            >
              <div style="font-size: 16px; margin-right: 10px">+964</div>
              <v-text-field
                label="Phone Number"
                placeholder="7701234567"
                v-model="customerInfoData.phone_number"
                :error-messages="errors.collect('Phone Number')"
                type="number"
                v-validate="'required'"
                data-vv-name="Phone Number"
              >
              </v-text-field>
            </div>
          </v-flex>

          <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.address"
          >
            <v-text-field
              label="Address"
              v-model="customerInfoData.address"
              :error-messages="errors.collect('Address')"
              v-validate="'required'"
              data-vv-name="Address"
            >
            </v-text-field>
          </v-flex>

          <v-flex
            xs10
            sm10
            md5
          >
            <v-btn
              type="submit"
              style="height:auto; width: 100%; margin-bottom: 5%"
              color="success"
            >Save</v-btn>
          </v-flex>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  mounted() {
    this.getLoggedInUser()
    this.assignUserData()
    this.$router.push('/my-order')
    // this.getBranchesList()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      branchesList: [],
      fillCustomerInfoUrl: 'api/users/web/create-profile',
      emailHint: false,
      errorResponse: false,
      successResponse: false,
      errorMessages: {
        email: '',
        phone_number: ''
      },
      successMessage: '',
      loggedInUserData: {},
      customerInfoData: {
        full_name: '',
        email: '',
        phone_number: '',
        address: ''
      }
    }
  },

  methods: {
    // sendOtp() {
    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .get('api/test-otp', { headers: { Authorization: 'Bearer ' + token } })
    //     .then(res => {
    //       console.log(res.data)
    //     })
    // },

    // getBranchesList() {
    //   this.branchesList = []

    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } })
    //     .then(response => {
    //       response.data.forEach(r => {
    //         this.branchesList.push({ text: r.branch_name, value: r.branch_id })
    //       })
    //     })
    // },

    assignUserData() {
      this.customerInfoData.full_name = this.loggedInUserData.full_name
      this.customerInfoData.email = this.loggedInUserData.email
      this.customerInfoData.phone_number = this.loggedInUserData.phone_number
      this.customerInfoData.address = this.loggedInUserData.address
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          let token = localStorage.getItem('access_token')

          let phone = this.customerInfoData.phone_number
          if (!this.customerInfoData.phone_number.startsWith('+964')) {
            phone = '+964' + this.customerInfoData.phone_number
          }

          const payload = {
            ...this.customerInfoData,
            phone_number: phone
          }

          axios.post(this.fillCustomerInfoUrl, payload, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(() => {
            this.errorResponse = false
            this.successResponse = true
            this.getUser()
          }).then(() => {
            this.$router.push('/my-order')
          }).catch(error => {
            if (error.response.data.message.email) {
              this.errorMessages.phone_number = ''
              this.errorMessages.email = error.response.data.message.email[0]
            } else if (error.response.data.message.phone_number) {
              this.errorMessages.email = ''
              this.errorMessages.phone_number = error.response.data.message.phone_number[0]
            } else if (error.response.data.message) {
              this.errorMessages.email = ''
              this.errorMessages.phone_number = error.response.data.message
            }
            this.errorResponse = true
            this.successResponse = false
          }).then(() => {
            let b = this
            setTimeout(function () {
              b.errorResponse = false
            }, 4000)
          })
        }
      })
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
          this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
        })
        .then(() => {
          location.reload(true)
        })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/home.vue